module.exports = __webpack_public_path__ + "static/media/Jermaime_3_Everyday Seamless Shorts.8c5d8768.jpeg";